import { v1ApiClient } from '@/services/index';

import type { SlackNotificationT } from './types';

const slackWebhookServices = {
  async createSlackWebhookInfo(code: string, workspaceAlias: string) {
    await v1ApiClient.post(
      `/workspaces/${workspaceAlias}/slack_incoming_webhooks`,
      {
        code,
        redirect_uri: import.meta.env.VITE_PUBLIC_WEBHOOK_URL,
      },
    );
    return true;
  },
  async fetchSlackWebhookInfos(
    workspaceAlias: string,
  ): Promise<SlackNotificationT[]> {
    const res = await v1ApiClient.get(
      `/workspaces/${workspaceAlias}/slack_incoming_webhooks`,
    );
    return res.data;
  },
};

export default slackWebhookServices;
